import ResetPasswordSignedIn from './ResetPasswordSignedIn';

export default ResetPasswordSignedIn;
